import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { AppSettingsService } from '../config/config-service';

export interface InvestmentConsultationRequest {
  name: string;
  email: string;
  phone: string;
  preferredOffice: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class InvestmentConsultationService {
  private apiUrl = ''; 

  constructor(private http: CommonService,  private appSettingsService: AppSettingsService) {
    this.apiUrl = this.appSettingsService.getSettings().apiEndPoint || '';
  }

  submitConsultation(request: InvestmentConsultationRequest): Observable<any> {
    return this.http.post(this.apiUrl + '/api/investmentConsultations/createConsultation', request );
  }
}